import { checkParams, zeroUnit, soFarDate } from '../../utils'
import { formatTime, formatDate, formatDatetime } from '../../filter'

function isTargetPassenger(accidentInfo) {
	// 是否为标的车乘客
	return (
		accidentInfo &&
		accidentInfo.injuryType === '02' &&
		accidentInfo.position === '02'
	)
}

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	if (this.isMotion || this.isNewMotion || this.isResurvey) {
		return false
	}

	let arr = []
	const accidentInfo = injured.accidentInfo || ''

	if (this.isCarInsurance) {
		arr = arr.concat([
			{
				label: '类型',
				value: setting.injuryIdentityMap[accidentInfo.injuryType],
			},
			{
				label: '出行方式',
				value: setting.trafficSituationMap[accidentInfo.travelModel],
			},
			{
				label: '人员位置',
				value: setting.injuryPositionMap[accidentInfo.position],
			},
		])
		if (
			accidentInfo.injuryType === '02' &&
			accidentInfo.position === '01' &&
			accidentInfo.insuredRelation
		) {
			arr.push({
				label: '伤者与被保险人关系',
				value:
					accidentInfo.insuredRelation === '06'
						? accidentInfo.otherContent
						: setting.injuredRelationMap[accidentInfo.insuredRelation],
			})
		}
		//平安定制
		if (this.isFirstVisit && this.isPAIC) {
			arr = arr.concat([
				{
					label: '伤者事故责任',
					value: setting.blameTypeMap[accidentInfo.blame],
				},
				{
					label: '是否上下班途中',
					value: setting.yesNoMap[accidentInfo.onWay],
				},
			])
		}
		if (this.isFirstVisit) {
			arr = arr.concat([
				{
					label: '自身有无违法行为',
					value: setting.isPeccancyMap[accidentInfo.isIllegal],
				},
				{
					label: '对方有无违法行为',
					value: setting.isPeccancyMap[accidentInfo.otherIllegal],
				},
			])

			if (isTargetPassenger(accidentInfo)) {
				arr.push({
					label: '是否是运营车辆',
					value: setting.yesNoMap[accidentInfo.operatingVehicles],
				})

				if (accidentInfo.operatingVehicles === '1') {
					arr = arr.concat([
						{
							label: '目的地',
							value: accidentInfo.destination,
						},
						{
							label: '出发地',
							value: accidentInfo.depart,
						},
						{
							label: '是否有支付金额',
							value:
								accidentInfo.payment === '1'
									? zeroUnit(accidentInfo.paymentAmount, '元')
									: setting.haveNoneMap[accidentInfo.payment],
						},
						{
							label: '与驾驶员关系',
							value: accidentInfo.driverRelation,
						},
					])
				}
			}
		}
	}
	if (!this.isCarInsurance && this.isPAIC) {
		arr = arr.concat([
			{
				label: '伤者事故责任',
				value: setting.blameTypeMap[accidentInfo.blame],
			},
			{
				label: '是否上下班途中',
				value: setting.yesNoMap[accidentInfo.onWay],
			},
		])
	}

	const subList = []

	if (this.isCarInsurance && !this.isPAIC) {
		subList.push({
			title: '司机特征',
			children: [
				{
					label: '身高',
					value:
						setting.driverFeatureMap[accidentInfo.driverFeature] ||
						accidentInfo.driverHeight,
				},
				{
					label: '是否戴眼镜',
					value:
						setting.driverFeatureMap[accidentInfo.driverFeature] ||
						setting.yesNoMap[accidentInfo.driverGlasses] ||
						setting.driverFeatureMap[accidentInfo.driverGlasses],
				},
				{
					label: '事发时司机衣服颜色',
					value:
						setting.driverFeatureMap[accidentInfo.driverFeature] ||
						accidentInfo.driverClothesColor,
				},
			],
		})
		subList.push({
			title: '事故车辆特征',
			children: [
				{
					label: '车辆类型',
					value:
						setting.accidentFeatureMap[accidentInfo.accidentFeature] ||
						setting.carTypeMap[accidentInfo.carType],
				},
				{
					label: '车辆颜色',
					value:
						setting.accidentFeatureMap[accidentInfo.accidentFeature] ||
						accidentInfo.carColor,
				},
			],
		})
	}
	let duringAccArr = []
	duringAccArr.push({
		label: '日期',
		value: formatDatetime(accidentInfo.accTime),
	})
	if (!this.isPAIC) {
		duringAccArr.push({
			label:
				(this.isAccidentInsurance || this.isLiabilityInsurance) &&
				this.isFirstVisit
					? '事故发生地点'
					: '地点',
			value: accidentInfo.address,
		})
	}
	if (this.isPAIC) {
		duringAccArr.push({
			label: '地点',
			value: accidentInfo.formatAddress + accidentInfo.address,
		})
	}
	duringAccArr.push({
		label: this.isHealthInsurance ? '诊疗经过' : '事故经过',
		value: accidentInfo.accDesc,
	})

	let accidentArr = []
	if (this.isConstructionAccident && this.isFirstVisit && !this.isPAIC) {
		accidentArr.push({
			label: '受伤时处在的具体位置',
			value: accidentInfo.injuryLocation,
		})
	}

	if (
		(this.isAccidentInsurance || this.isLiabilityInsurance) &&
		this.isFirstVisit &&
		!this.isPAIC
	) {
		accidentArr = accidentArr.concat([
			{
				label: '受伤时工作内容',
				value: accidentInfo.atTimeWorkContent,
			},
			{
				label: '出险时受伤部位',
				value: accidentInfo.atTimeInjuryPart,
			},
		])
	}

	if (this.isAccidentInsurance && this.isFirstVisit && !this.isPAIC) {
		accidentArr.push({
			label: '事故时是否有工作防护',
			value:
				accidentInfo.workProtection === '1'
					? accidentInfo.workProtectionDesc
					: setting.yesNoMap[accidentInfo.workProtection],
		})
	}

	if (
		(this.isAccidentInsurance || this.isLiabilityInsurance) &&
		this.isFirstVisit &&
		!this.isPAIC
	) {
		accidentArr = accidentArr.concat([
			{
				label: '事故时目击者姓名',
				value: accidentInfo.witnessName,
			},
			{
				label: '事故时目击者的工作岗位',
				value: accidentInfo.witnessJob,
			},
			{
				label: '目击者联系电话',
				value: accidentInfo.witnessMobile,
			},
		])
	}

	if (this.isConstructionAccident && this.isFirstVisit && !this.isPAIC) {
		accidentArr.push(
			{
				label: '事故后上报领导姓名',
				value: accidentInfo.leaderName,
			},
			{
				label: '领导电话',
				value: accidentInfo.leaderMobile,
			}
		)
	}

	duringAccArr = duringAccArr.concat(accidentArr)

	subList.push({
		title: this.isHealthInsurance ? '诊疗经过' : '事故经过',
		children: duringAccArr,
	})

	const obj = {
		title: this.isCarInsurance
			? '交通事故信息'
			: this.isHealthInsurance
			? '出险信息'
			: '事故信息',
		children: arr,
		subList,
	}

	return obj
}
